import {createSlice, type PayloadAction} from "@reduxjs/toolkit";
import {type MailServerHealth} from "../model/mailServer/MailServer.ts";
import {authReducerActions} from "./authReducer.ts";

interface MailServerHealthState {
    health: MailServerHealth;
    loaded: boolean;
}

const initialState: MailServerHealthState = {
    health: "UNKNOWN",
    loaded: false,
};

export const mailServerHealthReducer = createSlice({
    name: "mailServerHealth",
    initialState,
    reducers: {
        setHealth: (state, action: PayloadAction<MailServerHealth>) => {
            state.health = action.payload;
            state.loaded = true;
        },
    },
    extraReducers: builder => {
        builder.addCase(authReducerActions.logoutSuccess, () => initialState);
        // the health belongs to the garage looked at: entering, switching or leaving a support context loads it anew (#56913)
        builder.addCase(authReducerActions.startSupportContext, () => initialState);
        builder.addCase(authReducerActions.endSupportContext, () => initialState);
    },
});

export const mailServerHealthActions = mailServerHealthReducer.actions;

export default mailServerHealthReducer.reducer;
